<template>
    <KActionBar
        :visible="visible && !dismissed"
        class="article-cta-bar"
        label="Article recommendation"
    >
        <KButton
            class="article-cta-bar__close"
            variant="ghost"
            size="sm"
            aria-label="Dismiss recommendation"
            @click="dismiss"
        >
            <template #icon-start>
                <Icon name="tabler:x" />
            </template>
        </KButton>

        <div class="article-cta-bar__copy">
            <h2
                v-if="title"
                class="article-cta-bar__title k-heading-5"
            >
                {{ title }}
            </h2>
            <p
                v-if="text"
                class="article-cta-bar__text"
            >
                {{ text }}
            </p>
        </div>
        <template #actions>
            <KButton
                as="a"
                class="article-cta-bar__action"
                :href="link"
                :label="button"
                target="_blank"
                rel="noopener nofollow"
                @click="emit('click')"
            />
        </template>
    </KActionBar>
</template>

<script setup>
import { KActionBar, KButton } from '@vemedia/karibu'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'

defineProps({
    title: String,
    text: String,
    link: {
        type: String,
        required: true,
    },
    button: String,
})

const emit = defineEmits(['click', 'dismiss', 'show'])
const visible = ref(false)
const dismissed = ref(false)

function dismiss() {
    dismissed.value = true
    emit('dismiss')
}

function handleScroll() {
    visible.value = window.scrollY > 400
        && window.scrollY < document.body.scrollHeight - window.innerHeight - 400
}

watch(visible, (isVisible) => {
    if (isVisible && !dismissed.value) {
        emit('show')
    }
})

onMounted(() => {
    window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss">
@use 'article-cta-bar';
</style>
